import React, { useState } from 'react';
import {
  Modal,
  Pressable,
  ScrollView,
  Text,
  View,
  StyleSheet,
} from 'react-native';
import { useLanguage } from '../contexts/LanguageContext';

export default function MonthYearSelect({
  value,
  kind,
  label,
  disabled,
  onChange,
}: {
  value: number;
  kind: 'year' | 'month';
  label: string;
  disabled?: boolean;
  onChange: (value: number) => void;
}) {
  const [open, setOpen] = useState(false);
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  const options =
    kind === 'month'
      ? Array.from({ length: 12 }, (_, i) => i + 1)
      : Array.from({ length: 16 }, (_, i) => year + i);
  const display = (n: number) =>
    kind === 'month' ? String(n).padStart(2, '0') : String(n);
  return (
    <>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={label}
        disabled={disabled}
        onPress={() => setOpen(true)}
        style={[s.select, disabled && s.disabled]}
      >
        <Text numberOfLines={1} style={s.text}>
          {display(value)}
          {disabled ? '' : ' ▾'}
        </Text>
      </Pressable>
      <Modal
        visible={open}
        transparent
        animationType="fade"
        onRequestClose={() => setOpen(false)}
      >
        <Pressable style={s.overlay} onPress={() => setOpen(false)}>
          <View style={s.sheet}>
            <Text style={s.heading}>{label}</Text>
            <ScrollView>
              {options.map((option) => (
                <Pressable
                  key={option}
                  accessibilityRole="radio"
                  accessibilityState={{ checked: value === option }}
                  onPress={() => {
                    onChange(option);
                    setOpen(false);
                  }}
                  style={[s.option, option === value && s.selected]}
                >
                  <Text>{display(option)}</Text>
                </Pressable>
              ))}
            </ScrollView>
            <Pressable onPress={() => setOpen(false)} style={s.option}>
              <Text>{t('common.cancel')}</Text>
            </Pressable>
          </View>
        </Pressable>
      </Modal>
    </>
  );
}
const s = StyleSheet.create({
  select: {
    flex: 1,
    minWidth: 0,
    height: 34,
    borderWidth: 1,
    borderColor: '#CBD5E1',
    borderRadius: 6,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFF',
  },
  text: { fontSize: 13, color: '#334155' },
  disabled: { backgroundColor: '#F1F5F9' },
  overlay: {
    flex: 1,
    backgroundColor: '#0006',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  sheet: {
    backgroundColor: '#FFF',
    padding: 16,
    width: '100%',
    maxWidth: 300,
    maxHeight: '70%',
    borderRadius: 12,
  },
  heading: { fontWeight: '700', marginBottom: 8 },
  option: { padding: 12 },
  selected: { backgroundColor: '#DBEAFE' },
});
